import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class HumidityInstructionService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<HumidityInstruction[]> => {
    return this.apiHttp.get<HumidityInstruction[]>("humidityinstructions");
  };

  public get = (id: number): Observable<HumidityInstruction> => {
    return this.apiHttp.get<HumidityInstruction>(`humidityinstructions/${id}`);
  };
}

export interface HumidityInstruction {
  id: number;
  name: string;
  isActive: boolean;
  requiresFollowup: boolean;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/humidity-instruction.service.ts